/**
 * Created by xiewu on 2016/11/26.
 */
//通知管理视频交互
function InfoManageVideo(opt){
    this.defaultSetting={
        event:'mouseover'
    }
    $.extend(this.defaultSetting,opt);
    this.videoIndex=-1;
    this.videoMain=$(this.defaultSetting.sectionId);
    this.videoNav=this.videoMain.find('[data-infovideo-nav]');
    this.videoCon=this.videoMain.find('[data-infovideo-con]');
    this.videoList=this.videoCon.find('video');
    this.totalNum=this.videoCon.length;
    this.init();
}
//初始化
InfoManageVideo.prototype.init=function(){
    this.addEvent();
}
//事件绑定
InfoManageVideo.prototype.addEvent=function(){
    var This=this;
    //导航绑定事件
    this.videoNav.on(this.defaultSetting.event,function(){
        This.setPlayIndex($(this).index());
    })
    this.addVideoEvent();//视频事件添加
}
//视频事件添加
InfoManageVideo.prototype.addVideoEvent=function(){
    var This=this;
    //视频播放控制
    this.videoList.each(function(e){
        this.onended=null;
        this.onended=function(){
            This.startPlay();
        }
    })
}
//设置当前播放视频
InfoManageVideo.prototype.setPlayIndex=function(index){
    var This=this;
    //停止所有视频播放
    this.stopPlay();
    //导航高亮效果
    this.videoNav.removeClass('active').eq(index).addClass('active');
    //播放当前视频
    //this.videoCon.animate
    this.videoCon.removeClass('active')
        .eq(index).addClass('active');
    this.videoList.eq(index).get(0).play();
    // this.videoList.eq(index).animate({'opacity':1},400,function(){
    //     This.videoList.eq(index).get(0).play();
    // });
}
//停掉所有视频
InfoManageVideo.prototype.stopPlay=function(){
    this.videoList.each(function(){
        //$(this).css({'opacity':0});
        this.pause();
    })
}
//自动播放
InfoManageVideo.prototype.startPlay=function(){
    this.videoIndex+=1;//自动播放
    if(this.videoIndex>=this.totalNum){
        this.videoIndex=0;
    }
    this.setPlayIndex(this.videoIndex);
}
module.exports=InfoManageVideo;


/*****************
 ** WEBPACK FOOTER
 ** ./js/core/videoLinkPlay.js
 ** module id = 3
 ** module chunks = 0
 **/